
import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import { IconedBox } from 'views/rebranded-module/common/components/UI/NewMainWidget/IconedBox';

interface StyledBoxProps {
  bordered?: boolean;
  error?: boolean;
}
interface StyledIconedBoxProps {
  error?: boolean;
}

const StyledBox = styled(Box)<StyledBoxProps>(({ theme, bordered, error }) => ({
  '& .NWLFInputContainer':{
  border: bordered ? `1px solid ${theme.palette.border[3]}`: 0,
  borderRadius: bordered &&theme.spacing(0.5),
  borderColor: error && theme.palette.error.main ,
  overflow: 'hidden',
  [theme.breakpoints.down('md')]: {
    border: `1px solid ${theme.palette.border[3]}`,
    borderRadius: theme.spacing(0.5),
    borderColor: error && theme.palette.error.main ,
  },

},
}));

export const StyledIconedBox = styled(IconedBox)<StyledIconedBoxProps>(({ theme, error }) => ({
  '& .WidgetInputLabel': {
    position: 'absolute',
    fontSize: theme.typography.pxToRem(10),
    textTransform: 'uppercase',
    lineHeight:  theme.typography.pxToRem(10),
    color: error ? theme.palette.error.main : theme.palette.text.secondary,
    left: theme.spacing(7),
    top: theme.spacing(2.25),
    zIndex: 1,
  },
}));

export default StyledBox;
